import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";
import getLink, { LINK_TYPE } from "@/lib/links";
import { useTranslation } from "react-i18next";
import { useAuthContext } from "@/context/AuthContext";
import { fireTagManagerEvent } from "@/services/tagmanager";
import axios from "axios";

export const COOKIES_ACCEPTED_KEY =
  "WV5B7436BV34RCQ" + import.meta.env.VITE_DASHBOARD_URI;
export const COOKIES_REFUSED_KEY =
  "CV2365B4768N574" + import.meta.env.VITE_DASHBOARD_URI;

const isProd = import.meta.env.VITE_ROBOTS_POLICY === "all";

export const initCookies = () => {
  const isAccepted = window.localStorage.getItem(COOKIES_ACCEPTED_KEY);
  // const isRefused = window.localStorage.getItem(COOKIES_REFUSED_KEY);

  if (isAccepted) allCookies();
  // else onlyEssentialCookies();
};

const allCookies = () => {
  if (isProd) fireTagManagerEvent("cookies", { cookies: "granted" });
};

async function sendConsent(payload: {
  email?: string;
  target?: string;
  consent: boolean;
}): Promise<{
  email?: string;
  target?: string;
  consent: boolean;
}> {
  const response = await axios.post("/consent", {
    email: payload.email,
    target: payload.target,
    consent: payload.consent,
  });
  return response.data;
}

export default function CookiesBanner() {
  const { t } = useTranslation();
  const [cookiesAccepted, setCookiesAccepted] = useState(true);
  const user = useAuthContext();

  const onAcceptCoockies = async (accepted: boolean) => {
    // save privacy info
    try {
      await sendConsent({
        email: user.userEmail ? user.userEmail : "",
        target: "AcceptCoockies",
        consent: accepted,
      });
    } catch (error) {
      console.log(error);
    }

    window.localStorage.setItem(COOKIES_ACCEPTED_KEY, accepted.toString());
    setCookiesAccepted(true);
    // onlyEssentialCookies();
  };

  useEffect(() => {
    const isAccepted = window.localStorage.getItem(COOKIES_ACCEPTED_KEY);
    const isRefused = window.localStorage.getItem(COOKIES_REFUSED_KEY);

    setCookiesAccepted(isAccepted || isRefused ? true : false);
  }, []);

  if (cookiesAccepted) return <></>;

  return (
    <div style={{ zIndex: 1000 }} className="fixed bottom-0 w-full p-3">
      <div className="flex w-full h-full">
        <div className="flex flex-col md:flex-row gap-4 p-4 bg-white rounded-xl shadow-xl w-full border-[#ddd] border">
          <div
            onClick={() => {
              setCookiesAccepted(true);
            }}
            className="cursor-pointer bg-[#9AFEE3] flex justify-center items-center w-[25px] h-[25px] rounded-full"
          >
            x
          </div>

          <div className="text">
            <p>{t("cookies.text")}</p>
            <u>
              <a
                href={getLink(LINK_TYPE.COOCKIES)}
                target="_blank"
                className="text-[#9AFEE3]"
              >
                {t("cookies.policy")}
              </a>
            </u>
          </div>

          <div className="flex flex-col gap-3">
            <Button
              className="w-full"
              variant="takyon"
              size="sm"
              onClick={() => {
                onAcceptCoockies(true);
                allCookies();
              }}
            >
              {t("cookies.accept")}
            </Button>
            <Button
              className="w-full"
              size="sm"
              variant="secondary"
              onClick={() => {
                onAcceptCoockies(false);
              }}
            >
              {t("cookies.refuse")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
